export const CHAT = 'Chat';
export const INFO = 'Info';
export const MATERIAL = 'Material';
export const RESOURCES = 'Resources';
export const TASKS = 'Tasks';
export const TYPE_A_MESSAGE = 'Type a message ...';
export const LOGOUT_ALL_DEVICES = 'Logout From All Devices';
export const LAST_ACTIVE = 'Last Active';
export const NEW_ACCOUNT = 'New Account';
export const ACCOUNTS = 'Accounts';
export const COPY = 'Copy';
export const PIN = 'Pin';
export const FORWARD = 'Forward';
export const REPLY = 'Reply';
export const SEND_TO = 'Message';
export const MESSAGE = 'Message';
export const DELETE_MSG = 'Delete this message?';
export const DELETE_FOR_ME = 'Delete for me';
export const DELETE_FOR_EVERYONE = 'Delete for everyone';
export const CHANGE_NAME = 'Change Name';
export const UPDATE_STATUS = 'Update Status';
export const CHANGE_AVATAR = 'Change Avatar';
export const ONLINE = 'Online';
export const LAST_ACTIVITY = 'Last activity: ';
export const CITY_SESSION = session => `Started in ${session.city} - ${session.country}`;
export const SESSION_REMOVE_MSG = 'Are you sure you want to remove this session';
export const ACCOUNT_REMOVE_MSG = 'Are you sure you want to remove this account';
export const UNREAD_MESSAGES = 'UNREAD MESSAGES';



// WEBPACK FOOTER //
// ./src/lang/en/middle.js